<template>
    <div class="languageContent">
        <div class="selectFields">
            <TextField class="selectOption"
                id="select"
                type="select"
                :label="siteContent.language"
                v-model="language"
                @input="changeLanguage">
                <option :selected="preferences.language === 'hu'" value="hu">🇭🇺 HU</option>
                <option :selected="preferences.language === 'en'" value="en">🇬🇧 EN</option>
            </TextField>
            <Toggle class="sensitiveToggle"
                v-if="auth.id"
                v-model="showSensitive"
                @toggle="toggleSensitivePreference"
                :label="content.displaySensitiveByDefault">
                <template slot="description">
                    Learn more about our
                    <router-link to="/community-guidelines">
                        Community Guidelines
                    </router-link>
                </template>
            </Toggle>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Language',
        props: {
            content: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                language: '',
                showSensitive: false
            }
        },
        mounted() {
            if(this.preferences.showSensitive === true) {
                this.showSensitive = true
            } else {
                this.showSensitive = false
            }
        },
        methods: {
            ...mapActions('users',['setPreferredLanguage','setSensitivePreference']),

            changeLanguage() {
                this.setPreferredLanguage(this.language)

                const html = document.documentElement
                if(this.language === 'hu') {
                    html.setAttribute('lang', 'hu')
                } else {
                    html.setAttribute('lang', 'en')
                }
            },
            toggleSensitivePreference() {
                this.setSensitivePreference(this.showSensitive)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .sensitiveToggle {
        margin-top: 2rem;
    }

    .description {
        font-size: 0.875rem;
        color: var(--color-grey-600);
        font-family: $font-primary;
        font-weight: 500;
        margin: 0;
    }
</style>